<template>
  <div class="ManagementSKU">
    <div class="left">
      <el-button
        :disabled="fbDisabled"
        type="primary"
        @click="handleFenpei"
        style="margin-left: 10px; margin-bottom: 6px"
        v-if="str && str.system < 3"
        >分配</el-button
      >
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        style="width: 90%; margin-left: 5%; margin-bottom: 5px"
      >
      </el-input>
      <el-tree
        :data="Treedata"
        node-key="id"
        :props="defaultProps"
        :default-expanded-keys="['-1']"
        draggable
        :highlight-current="highlight"
        :allow-drop="allowDrop"
        @node-drop="sort"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        ref="tree"
        :filter-node-method="filterNode"
      >
        <span
          class="custom-tree-node"
          slot-scope="{ node, data }"
          @mouseover="mouseover(data)"
          @mouseleave="mouseleave(data)"
        >
          <span>{{ data.name }}</span>
        </span>
      </el-tree>
    </div>

    <div class="right">
      <div class="Release">
        <el-form
          :model="selectForm"
          ref="selectForm"
          :label-position="labelPosition"
          label-width="120"
          inline
          class="custom-formScreen"
        >
          <el-form-item
            label="选择分公司"
            v-if="
              [1].includes(str.type) &&
              str.superDepartmentName !== '客服部' &&
              str.superDepartmentName !== '常规客服部'
            "
          >
            <el-select
              v-model="value6"
              placeholder="请选择"
              @change="shopChange6"
              value-key="company_id"
              filterable
            >
              <el-option
                v-for="item in arr6"
                :key="item.company_id"
                :label="item.companyName"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择子公司"
            prop="sonCompany"
            v-if="[2, 1].includes(str.type)"
          >
            <el-select
              v-model="value7"
              placeholder="请选择"
              value-key="rid"
              @change="shopChange7"
              filterable
            >
              <el-option
                v-for="item in arr7"
                :key="item.company_id"
                :label="item.companyName"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择分部门" v-if="!disabledInput2">
            <el-select
              v-model="value2"
              filterable
              placeholder="请选择"
              @change="shopChange2"
            >
              <el-option
                v-for="item2 in this.arr1"
                :key="item2.value"
                :label="item2.departmentName"
                :value="item2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择组" v-if="!disabledInput3">
            <el-select
              v-model="value3"
              filterable
              placeholder="请选择"
              @change="shopChange3"
            >
              <el-option
                v-for="item3 in this.arr2"
                :key="item3.value"
                :label="item3.groupName"
                :value="item3"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择员工" v-if="!disabledInput4">
            <el-select
              v-model="value4"
              filterable
              placeholder="请选择"
              @change="shopChange4"
            >
              <el-option
                v-for="item4 in this.arr3"
                :key="item4.value"
                :label="item4.roleUserName"
                :value="item4"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startTime">
            <el-date-picker
              v-model="selectForm.startTime"
              align="right"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <!-- @change="startTime" -->
          </el-form-item>
          <el-form-item label="结束日期" prop="endTime">
            <el-date-picker
              v-model="selectForm.endTime"
              align="right"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="模糊检索" prop="searchStr">
            <el-input
              v-model="selectForm.searchStr"
              placeholder="请输入检索内容"
            ></el-input>
          </el-form-item>
          <el-button type="primary" style="margin-left: 10px" @click="Search2"
            >搜索</el-button
          >
          <el-button type="primary" @click="searchReset">重置</el-button>
        </el-form>
        <div class="summary_bag">
          <div class="summary_complete_bag"></div>
          <!-- 符合查询条件的产品共-->
          <div class="summary_pagenum">
            <div class="summary_query">
              符合查询条件的产品共
              <span>{{ count }}</span>
              件
            </div>
          </div>
          <div class="summary_content">
            <div style="display: flex; align-items: center">
              <div class="summary_batch" style="width: initial">
                <span>已选择产品{{ piece }}件</span>
                <template v-if="str && str.system < 3">
                  <span @click="setFenlei()" style="cursor: pointer"
                    >设置分类</span
                  >
                </template>
                <template v-if="str && str.system === 5">
                  <span @click="platformUpload('batch')" style="cursor: pointer"
                    >平台应用</span
                  >
                  <span @click="multiplex('batch')" style="cursor: pointer"
                    >Listing复用</span
                  >
                </template>
              </div>
              <div
                style="border-left: 1px solid #2c8dff; padding-left: 12px"
                v-if="str && str.system < 3"
              >
                <el-checkbox v-model="selectForm.isFenlei"
                  >无分类查询</el-checkbox
                >
              </div>
            </div>

            <div class="summary_list">
              <!-- 头部 -->
              <el-table
                ref="tableList"
                :data="tableList"
                style="width: 100%"
                v-loading="load_data"
                element-loading-text="拼命加载中"
                border
                @selection-change="on_batch_select"
                :header-cell-style="iscenter"
                stripe
                class="pg-table"
                :cell-class-name="'pg-cell'"
                :header-cell-class-name="'pg-header-cell'"
                fit
              >
                <!-- :cell-style="style" -->
                <el-table-column
                  width="50"
                  type="selection"
                  align="center"
                ></el-table-column>
                <el-table-column label="图片" width="120" align="left">
                  <template slot-scope="scope">
                    <el-popover
                      trigger="hover"
                      placement="right"
                      v-if="scope.row.imgUrl && scope.row.imgUrl.length > 0"
                      :open-delay="600"
                    >
                      <img
                        :src="JSON.parse(scope.row.imgUrl)[0]"
                        class="prduct_img"
                        alt
                      />
                      <div class="scope_img" slot="reference">
                        <img :src="JSON.parse(scope.row.imgUrl)[0]" alt />
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  label="中文标题"
                  prop="chineseName"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  label="英文标题"
                  prop="englishName"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  label="产品分类"
                  prop="categoryFullName"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  width="100"
                  label="产品来源"
                  prop="source"
                  align="center"
                >
                  <template v-slot="scope">
                    <span v-if="scope.row.source === 1">Amazon</span>
                    <span v-else-if="scope.row.source === 2">精品</span>
                    <span v-else>其他</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="120"
                  label="创建时间"
                  prop="createTime"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  width="100"
                  label="创建人"
                  prop="roleId"
                  align="left"
                >
                </el-table-column>

                <el-table-column label="操作" :width="100" align="center">
                  <template slot-scope="scope">
                    <div>
                      <!--待完善、待发布、失败显示-->
                      <el-button type="primary" @click="clickDetails(scope.row)"
                        >详情</el-button
                      >
                    </div>
                    <div style="margin: 4px 0">
                      <el-button
                        type="primary"
                        @click="platformUpload('single', scope.row)"
                        >应用</el-button
                      >
                    </div>
                    <div>
                      <el-button
                        type="primary"
                        @click="multiplex('single', scope.row)"
                        >复用</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="summary_pagenum_block">
                <div class="block">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 20, 50, 100, 200, 500]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="count"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fenpei ref="fenpei"></fenpei>
    <fenlei ref="fenlei" @refresh="Search2"></fenlei>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="90%"
      top="5vh"
    >
      <pictures :imagesList="baseInfo.imgUrl"></pictures>
      <base-info :baseInfo="baseInfo"></base-info>
      <bianti
        :biantiList="baseInfo.tierVariation"
        v-if="baseInfo.tierVariation && baseInfo.tierVariation.length > 0"
      ></bianti>
      <caigou
        :sourceLink="baseInfo.sourceLink"
        v-if="baseInfo.sourceLink && baseInfo.sourceLink.length > 0"
      ></caigou>
      <!--    <listCom></listCom>-->
    </el-dialog>

    <!--  平台上传  -->
    <plantFormUpload
      v-if="uploadVisible"
      :visible="uploadVisible"
      :categoryStencilList="categoryStencilList"
      :sellerStencilList="sellerStencilList"
      :saveDisabled="saveDisabled"
      @cancelVisible="uploadVisible = false"
      @save="platformUploadFn"
    ></plantFormUpload>
    <!--  listing复用  -->
    <listingMultiplex
      v-if="multiplexVisible"
      :visible="multiplexVisible"
      :saveDisabled="saveDisabled"
      :roleInfo="roleInfo"
      :currentForm="currentForm"
      :parentSelectRows="selectRows"
      :multiplexType="multiplexType"
      @cancelVisible="multiplexVisible = false"
      @save="multiplexFn"
    ></listingMultiplex>
  </div>
</template>

<script>
import { ajaxPost, Baseurl, ajaxGet } from "@/api/api/api";
import fenpei from "./components/fenpei.vue";
import fenlei from "./components/fenlei.vue";
import bianti from "./components/bianti.vue";
import baseInfo from "./components/baseInfo.vue";
import pictures from "./components/pictures.vue";
import caigou from "./components/caigou.vue";
import plantFormUpload from "./components/plantFormUpload";
import listingMultiplex from "./components/listingMultiplex";

export default {
  name: "productDisplay",
  components: {
    caigou,
    pictures,
    baseInfo,
    bianti,
    fenpei,
    fenlei,
    plantFormUpload,
    listingMultiplex,
  },
  data() {
    return {
      baseInfo: {
        imagesList: [],
      },
      dialogVisible: false,
      title: "产品详情",
      //分配按钮是否可点击
      fbDisabled: true,
      filterText: "",
      Treedata: [],
      highlight: true,
      //选中的分类产品id
      categoryId: 0,
      defaultProps: {
        children: "children",
        label: "name",
      },
      batch_select: [],
      selectRows: [],
      state: "",
      //标识 1boss 2 部长 3分部长 4 组长 5普通员工
      system: "5",
      //角色id
      rid: "",
      labelPosition: "right",
      str: null,
      value2: "",
      //组
      value3: "",
      //员工
      value4: "",
      //分公司
      value6: "",
      //子公司
      value7: "",
      arr: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: [],
      arr6: [],
      arr7: [],
      //平台名称
      sellerType: "",
      disabledInput2: false,
      disabledInput3: false,
      disabledInput4: false,
      selectForm: {
        //是否是分类查询
        isFenlei: false,
        page: 1,
        size: 20,
        startTime: "", //开始时间
        endTime: "", //结束时间
        searchStr: "",
        //角色id
        staffId: "",
        system: null,
        //公司id
        companyId: "",
        releaseStatus: 88,
        isTranslation: 1,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate();
            },
          },
          {
            text: "上一月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-1);
            },
          },
          {
            text: "上两月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-2);
            },
          },
          {
            text: "上三月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-3);
            },
          },
        ],
      },
      //tabale loadding
      load_data: false,
      iscenter: {
        textAlign: "center",
        background: "#f8f8f8",
        color: "#232323",
      },
      currentPage: 1,
      size: 10,
      //page total
      count: 0,
      //已选数量
      piece: 0,
      tableList: [],

      roleInfo: {},
      /*平台上传*/
      platformType: undefined,
      categoryStencilList: [],
      sellerStencilList: [],
      uploadType: "single", //single  batch
      uploadVisible: false,
      saveDisabled: false,
      /*listing复用*/
      multiplexType: "single", //single  batch
      multiplexVisible: false,

      currentForm: {},
    };
  },
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem("role"));
    this.getPlatformTypeByStaffId(); // 获取平台类型
    this.getCategoryStencilList(); //获取分类模板
    this.getSellerStencilList(); //获取店铺模板
    this.init();
    this.getTreedata();
    this.get_table_data(0);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    init() {
      var str = JSON.parse(localStorage.getItem("role"));
      this.str = str;
      this.state = str.system;
      this.rid = str.rid;
      this.selectForm.staffId = this.str.rid;
      this.selectForm.system = this.str.system;
      this.selectForm.companyId = this.str.company_id;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: this.str.rid,
        system: this.str.system,
        companyId: this.str.company_id,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr = res.data.data.next;
        const { type: companyType } = this.str;
        if (
          companyType === 1 &&
          this.str.superDepartmentName !== "客服部" &&
          this.str.superDepartmentName !== "常规客服部"
        ) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr6 = res.data.data.next;
        } else if (
          companyType === 2 ||
          (companyType === 1 && this.str.superDepartmentName === "客服部") ||
          (companyType === 1 && this.str.superDepartmentName === "常规客服部")
        ) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr7 = res.data.data.next;
        } else if (
          this.state === 1 ||
          (this.str.type === 3 &&
            this.str.system === 5 &&
            this.str.superDepartmentName === "财务部") ||
          (this.str.type === 3 &&
            this.str.system === 5 &&
            this.str.superDepartmentName === "人事部")
        ) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr1 = res.data.data.next;
        } else if (this.state === 2) {
          this.disabledInput2 = false;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr1 = res.data.data.next;
        } else if (this.state === 3) {
          this.disabledInput2 = true;
          this.disabledInput3 = false;
          this.disabledInput4 = false;
          this.arr2 = res.data.data.next;
        } else if (this.state === 4) {
          this.disabledInput2 = true;
          this.disabledInput3 = true;
          this.disabledInput4 = false;
          this.arr3 = res.data.data.next;
        } else if (this.state === 5) {
          this.disabledInput2 = true;
          this.disabledInput3 = true;
          this.disabledInput4 = true;
          var sellerInfos = res.data.data.next;
          var newArr = [];
          var num = 0;
          for (var i = 0; i < sellerInfos.length; i++) {
            var shop = sellerInfos[i].countryMarks;
            var sellerId = sellerInfos[i].sellerId;
            for (var j = 0; j < shop.length; j++) {
              shop[j].sellerId = sellerId;
              newArr[num] = shop[j];
              // newArr[num] = shop[j];
              num++;
            }
          }
          this.arr4 = newArr;
          // this.arr4 = newArr.sort((a, b) => a.order - b.order);
        }
      });
    },
    //获取树形结构
    getTreedata() {
      this.fbDisabled = true;
      if (this.str.system == "1") {
        let params = {
          level: 1,
          pid: 0,
          //   "companyId": this.selectForm.companyId
          companyId: 9,
        };
        const API = Baseurl + "/baseCategoryController/selectBaseCategoryList";
        ajaxPost(API, params).then((res) => {
          if (res.data.code === 200) {
            this.$set(this.Treedata, 0, {
              name: "分类列表",
              children: [],
              menuType: 0,
              id: "-1",
            });
            res.data.data.forEach((item) => {
              this.$set(item, "menuType", 1);
              if (item.children) {
                item.children.forEach((val) => {
                  this.$set(val, "menuType", 2);
                  if (val.children) {
                    val.children.forEach((key) => {
                      this.$set(key, "menuType", 3);
                    });
                  }
                });
              }
            });
            this.Treedata[0].children = res.data.data;
            this.fbDisabled = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        const API = Baseurl + "/baseCategoryController/selectBaseCategoryByRid";
        ajaxPost(API, { rid: this.str.rid }).then((res) => {
          if (res.data.code === 200) {
            this.$set(this.Treedata, 0, {
              name: "分类列表",
              children: [],
              menuType: 0,
              id: "-1",
            });
            res.data.data.forEach((item) => {
              this.$set(item, "menuType", 1);
              if (item.children) {
                item.children.forEach((val) => {
                  this.$set(val, "menuType", 2);
                  if (val.children) {
                    val.children.forEach((key) => {
                      this.$set(key, "menuType", 3);
                    });
                  }
                });
              }
            });
            this.Treedata[0].children = res.data.data;
            this.fbDisabled = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //拖拽时判断目标节点是否被放置，type ,用来判断放在目标节点前、插入、后
    allowDrop(draggingNode, dropNode, type) {
      //pid是父节点id
      if (draggingNode.data.parentId === dropNode.data.parentId) {
        return type === "prev" || type === "next";
      } else {
        // 不同级进行处理
        return false;
      }
    },
    //拖拽修改顺序
    sort(_, dropNode) {
      let obj = {
        params: [],
      };
      for (let item of dropNode.parent.childNodes) {
        obj.params.push(item.data);
      }
      // this.updateOrderMe(obj)
    },
    //拖动后保存的接口
    // updateOrderMe(params) {
    //   const API = Baseurl + 'systemCategory/updateSort'
    //   ajaxPost(API, params)
    //       .then((res) => {
    //         if (res.data.code === 1) {
    //           // this.getTreedata()
    //           this.$message.success("修改成功");
    //         } else {
    //           this.$message.error(res.data.message)
    //         }
    //       })
    // },
    //点击节点更新列表
    handleNodeClick(val) {
      this.highlight = true;
      this.categoryId = val.id;
      this.selectForm.isFenlei = false;
      this.get_table_data(val.id);
    },
    //筛选节点  返回true 显示，false，隐藏
    filterNode(value, data) {
      // if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    mouseover(data) {
      if (data.menuType == 0) {
        this.$set(data, "plus", true);
        this.$set(data, "minus", false);
        this.$set(data, "edit", false);
      } else if (data.menuType == 3) {
        this.$set(data, "plus", false);
        this.$set(data, "minus", true);
        this.$set(data, "edit", true);
      } else if (data.menuType == 1 || data.menuType == 2) {
        this.$set(data, "plus", true);
        this.$set(data, "minus", true);
        this.$set(data, "edit", true);
      }
    },
    mouseleave(data) {
      this.$set(data, "plus", false);
      this.$set(data, "minus", false);
      this.$set(data, "edit", false);
    },
    calculationDate(type = 0) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = ((month + type - 1 + 12) % 12) + 1;
      this.selectForm.startTime = `${newYear}-${newMonth
        .toString()
        .padStart(2, "0")}-01 00:00:00`;

      const prevStamp =
        new Date(year, month + type, day).getTime() - 3600 * 1000 * 24 * day;
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${
        new Date(prevStamp).getMonth() + 1
      }-${new Date(prevStamp).getDate()}`;
      this.selectForm.endTime = `${prevMonth} 23:59:59`;
    },
    //获取表格数据
    get_table_data() {
      // if(!this.selectForm.isFenlei && !this.categoryId){
      //   this.$message.warning("请先选择分类id");
      //   return
      // }
      if (this.selectForm.isFenlei) {
        this.categoryId = null;
      }
      this.load_data = true;
      var begin = this.selectForm.startTime;
      if (begin == null || begin == "") {
        begin = "";
      } else {
        begin =
          new Date(this.selectForm.startTime)
            .toLocaleDateString()
            .replace(/\//g, "-") +
          " " +
          new Date(this.selectForm.startTime).toTimeString().substr(0, 8);
      }
      var end = this.selectForm.endTime;
      if (end == null || end == "") {
        end = "";
      } else {
        end =
          new Date(this.selectForm.endTime)
            .toLocaleDateString()
            .replace(/\//g, "-") +
          " " +
          new Date(this.selectForm.endTime).toTimeString().substr(0, 8);
      }
      //将startTime格式强转
      let searchobj = Object.assign({}, this.selectForm, {
        startTime: begin,
        endTime: end,
        page: this.currentPage,
        size: this.size,
        categoryId: this.categoryId,
        companyId: this.str.company_id,
        // companyId: 9,
        // source:'2'
      });
      ajaxPost(Baseurl + "baseProductController/selectBaseProducts", searchobj)
        .then((res) => {
          this.load_data = false;
          const { code, message, data } = res.data;
          if (code == 200) {
            this.tableList = data.list;
            this.count = data.total;
          } else {
            this.count = 0;
            this.$message.error(message);
          }
        })
        .catch(function (e) {});
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.sonCompany = [];
      this.get_table_data();
    },
    //修改size
    handleSizeChange(val) {
      this.size = val;
      this.get_table_data();
    },
    //修改current
    handleCurrentChange(val) {
      this.currentPage = val;
      this.get_table_data();
    },
    // 选中框
    Selection(item) {
      if (item.chatype) {
        this.piece++;
      } else {
        this.piece--;
      }
    },
    //左侧勾选项变化
    on_batch_select(val) {
      this.selectRows = val;
      var newarr = [];
      this.piece = val.length;
      for (var i = 0; i < val.length; i++) {
        newarr.push(val[i].id);
      }
      this.batch_select = newarr;
    },
    shopChange2(value2) {
      this.arr3 = [];
      this.arr4 = [];
      this.value3 = "";
      this.value4 = "";
      this.rid = value2.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value2.rid,
        system: 3,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr2 = res.data.data.next;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange3(value3) {
      this.arr4 = [];
      this.value4 = "";
      this.rid = value3.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value3.rid,
        system: 4,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        this.arr3 = res.data.data.next;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange4(value4) {
      this.rid = value4.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value4.rid,
        system: 5,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        var sellerInfos = res.data.data.next;
        var newArr = [];
        var ids = [];
        var num = 0;
        for (var i = 0; i < sellerInfos.length; i++) {
          var shop = sellerInfos[i].countryMarks;
          for (var j = 0; j < shop.length; j++) {
            newArr[num] = shop[j];
            ids[num] = shop[j].shopId;
            num++;
          }
        }
        this.arr4 = newArr;
        this.shopIds = res.data.data.shopIds;
      });
    },
    shopChange6(value6) {
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.arr7 = [];
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.value7 = "";
      this.selectForm.companyId = value6.company_id;
      this.rid = value6.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value6.rid,
        system: 1,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr7 = data.next;
          this.shopIds = data.shopIds;
        }
      });
    },
    shopChange7(value7) {
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.selectForm.companyId = value7.company_id;
      this.sellerType = "";
      this.rid = value7.rid;
      ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", {
        rid: value7.rid,
        system: 1,
        companyId: this.selectForm.companyId,
        sellerType: this.sellerType,
      }).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr1 = data.next;
          this.shopIds = data.shopIds;
        }
      });
      this.getItemList();
    },

    Search2() {
      this.currentPage = 1;
      this.get_table_data();
    },
    // 重置
    searchReset() {
      this.selectForm.startTime = undefined;
      this.selectForm.endTime = undefined;
      this.selectForm.searchStr = undefined;
      this.currentPage = 1;
      this.size = 10;
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.arr6 = [];
      this.arr7 = [];
      // this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.value6 = "";
      this.value7 = "";
      this.sellerType = "";

      this.init();
      this.get_table_data();
    },

    //选择开始时间
    startTime(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 00:00:00";
      this.selectForm.startTime = datetime;
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 23:59:59";
      this.selectForm.endTime = datetime;
    },
    clickDetails(row) {
      this.baseInfo = { ...row };
      this.baseInfo.imgUrl = this.baseInfo.imgUrl
        ? JSON.parse(this.baseInfo.imgUrl)
        : [];
      this.baseInfo.tierVariation = this.baseInfo.tierVariation
        ? JSON.parse(this.baseInfo.tierVariation)
        : [];
      this.baseInfo.sourceLink = this.baseInfo.sourceLink
        ? JSON.parse(this.baseInfo.sourceLink)
        : [];
      this.baseInfo.bluePoint = this.baseInfo.bluePoint
        ? JSON.parse(this.baseInfo.bluePoint)
        : [];
      this.dialogVisible = true;
    },
    //分配弹窗
    handleFenpei() {
      let treeData = JSON.stringify(this.Treedata);
      this.$refs.fenpei.handleFenpei(this.str.company_id, treeData);
    },
    //设置分类
    setFenlei() {
      if (this.batch_select && this.batch_select.length === 0) {
        this.$message.warning("请先勾选产品");
        return;
      }
      let treeData = JSON.stringify(this.Treedata);
      this.$refs.fenlei.handleFenlei(treeData, this.batch_select);
    },

    //=========平台上传=======//
    //获取分类模板
    getPlatformTypeByStaffId() {
      const sendData = {
        staffId: this.roleInfo.rid,
      };
      const API = Baseurl + "baseProductController/getPlatformTypeByStaffId";
      ajaxPost(API, sendData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.platformType = data?.platformType;
        }
      });
    },
    getCategoryStencilList() {
      const sendData = {
        staffId: this.roleInfo.rid,
      };
      const API = Baseurl + "baseProductController/getCategoryStencilList";
      ajaxPost(API, sendData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.categoryStencilList = data?.allergro || [];
        }
      });
    },
    //获取店铺模板
    getSellerStencilList() {
      const sendData = {
        staffId: this.roleInfo.rid,
      };
      const API = Baseurl + "baseProductController/getSellerStencilList";
      ajaxPost(API, sendData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.sellerStencilList = data?.allergro || [];
        }
      });
    },
    platformUpload(type, record) {
      if (type === "batch") {
        if (this.batch_select && this.batch_select.length === 0) {
          this.$message.warning("请先勾选产品");
          return;
        }
      }
      this.uploadType = type;
      this.currentForm = record;
      this.uploadVisible = true;
    },
    platformUploadFn({ categoryStencilObj, sellerStencilObj }) {
      // if (!categoryStencilObj && !sellerStencilObj) {
      //   this.$message.warning("请选择分类模板或者店铺模板");
      //   return;
      // }
      const sendData = {
        staffId: this.roleInfo.rid,
        platformType: this.platformType,
        ids:
          this.uploadType === "batch"
            ? this.batch_select
            : [this.currentForm.id],
        sellerStencil: sellerStencilObj
          ? {
              allergro: sellerStencilObj,
            }
          : null,
        categoryStencil: categoryStencilObj
          ? {
              allergro: categoryStencilObj,
            }
          : null,
      };
      const API = Baseurl + "baseProductController/exploitProduct";
      this.saveDisabled = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("操作成功，请到对应平台产品刊登中查看");
            this.$refs.tableList && this.$refs.tableList.clearSelection(); //清空选中数据
            this.uploadVisible = false;
          } else {
            this.$message.error(data.data);
          }
          this.saveDisabled = false;
        })
        .catch(() => {
          this.$message.error("操作失败");
          this.saveDisabled = false;
        });
    },

    //复用
    multiplex(type, record) {
      if (type === "batch") {
        if (this.batch_select && this.batch_select.length === 0) {
          this.$message.warning("请先勾选产品");
          return;
        }
      }
      this.multiplexType = type;
      this.currentForm = record;
      this.multiplexVisible = true;
    },

    multiplexFn(rows) {
      const sendData = rows?.map((ele) => {
        return {
          staffId: this.roleInfo.rid,
          productId: ele.productId,
          platformProductId: ele.platformProductId,
          platformType: this.platformType,
        };
      });
      const API = Baseurl + "baseProductController/reuseProduct";
      this.saveDisabled = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("操作成功，请到对应平台产品刊登中查看");
            this.$refs.tableList && this.$refs.tableList.clearSelection(); //清空选中数据
            this.multiplexVisible = false;
          } else {
            this.$message.error(data.data);
          }
          this.saveDisabled = false;
        })
        .catch(() => {
          this.$message.error("操作失败");
          this.saveDisabled = false;
        });
    },
  },
};
</script>

<style lang="scss">
.Release {
  width: 98%;
  // background: #F7F7F7;
  padding-bottom: 72px;
  .summary_bag {
    width: 98%;
    margin: auto;
    .summary_complete_bag {
      overflow: hidden;
      .summary_complete {
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 1px #eee solid;
        div {
          padding: 0 10px;
          height: 30px;
          border: #2c8dff 1px solid;
          line-height: 30px;
          text-align: center;
          color: #2c8dff;
          float: left;
          border-radius: 4px;
          cursor: pointer;
        }
        .active {
          background: #2c8dff;
          color: #fff;
        }
      }
    }
    .summary_pagenum {
      width: 100%;
      margin-bottom: 10px;
      overflow: hidden;
      background: #f5f5f5;
      .summary_query {
        width: 20%;
        float: left;
        padding: 0 10px;
        line-height: 32px;
        letter-spacing: 1px;
        color: #585858;
        span {
          color: #2c8dff;
        }
      }
      .block {
        float: right;
      }
    }
    .summary_content {
      width: 100%;
      border: 1px solid #eee;
      overflow: hidden;
      .summary_batch {
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
        span {
          display: block;
          float: left;
          line-height: 20px;
          margin: 10px 0px;
          padding: 0 20px;
          color: #2c8dff;
          overflow: hidden;
          border-left: 1px #2c8dff solid;
        }
        span:nth-child(1) {
          color: #000;
          border-left: 0px;
        }
      }
    }
    .summary_list {
      .scope_img {
        width: 55px;
        height: 55px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .oper {
        color: #2c8dff;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
.item_sku {
  width: 100%;
}
.custom-formScreen {
  ::v-deep {
    .el-form-item__content {
      width: calc(100% - 125px);
    }
  }
}
.zhankai_shouqi {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background: rgb(168, 168, 168);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  cursor: pointer;
}
.item_yuan {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-left: 5px;
}
.red_yuan {
  background: red;
  cursor: pointer;
}
.green_yuan {
  background: green;
}
.item_err {
  width: 120px;
  text-align: right;
  padding-right: 15px;
}
.item_err_content {
  width: calc(100% - 160px);
}

/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #ccc !important;
}
/deep/ .el-tree-node__content:hover {
  background: #eee !important;
}
.ManagementSKU {
  width: 98%;
  display: flex;
  // padding-bottom: 100px;
  justify-content: space-between;
  height: 100%;
  .block {
    margin-bottom: 20px;
  }
  .left {
    width: 15%;
    float: left;
    border: 1px solid #eee;
    padding: 10px 0;
    border-radius: 4px;
    height: calc(100% - 80px);
    overflow-y: auto;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
      .el-icon-minus {
        margin: 0 8px;
      }
    }
  }
  .right {
    width: 83%;
    .el-icon-s-data {
      cursor: pointer;
    }
    .summary_complete_bag {
      overflow: hidden;
      .summary_complete {
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 1px #eee solid;
        div {
          padding: 0 10px;
          height: 30px;
          border: #2c8dff 1px solid;
          line-height: 30px;
          text-align: center;
          color: #2c8dff;
          float: left;
          border-radius: 4px;
          cursor: pointer;
        }
        .active {
          background: #2c8dff;
          color: #fff;
        }
      }
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  .summary_pagenum {
    width: 100%;
    margin-bottom: 10px;
    overflow: hidden;
    background: #f5f5f5;
    .summary_query {
      padding: 5px 10px;
    }
  }
  .summary_pagenum_block {
    width: 1789px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;
    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
  /deep/ .el-dialog__header {
    background: rgb(236, 236, 236);
    border-radius: 2px 2px 0 0;
  }
}

//此处为列表页面
.prduct_img {
  width: 500px;
  height: 500px;
}
</style>
